(function () {
  const INJECTED_CLASS = 'js-cart-badges';
  const DEBUG = true; // set false when happy

  // --- utils ---
function money(cents) {
  // cents should be an integer
  const script = document.getElementById('boost-cart-script');
  const cur = (script && script.getAttribute('data-currency')) ||
              (window.Shopify && (window.Shopify.currency || window.Shopify.currency?.active)) ||
              'USD';

  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: typeof cur === 'string' ? cur : 'USD',
      currencyDisplay: 'symbol',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format((cents || 0) / 100);
  } catch (e) {
    // very safe fallback
    return '$' + ((cents || 0) / 100).toFixed(2);
  }
}

  async function getCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Cart fetch failed');
    return res.json();
  }

  // --- selectors based on your DOM ---
  const DRAWER_SEL = '#boost-cart-app';
  const LINE_SEL   = 'li.boost-cart__item';
  const PRICE_SEL  = '.boost-cart__item-price';

  // read identifiers
  const keyFromEl = el => el.getAttribute('data-key');
  const vidFromEl = el => {
    const v = el.getAttribute('data-variant-id');
    return v ? Number(v) : null;
  };

  // compare-at via product JSON (cache)
  const pjCache = new Map();
  function toCents(v) {
  if (v == null) return null;

  // Parse to a number (handles "29.99", "2999.00", 29.99, 2999, 299900)
  const num = typeof v === 'number'
    ? v
    : parseFloat(String(v).replace(/[^0-9.]/g, ''));

  if (isNaN(num)) return null;

  // Heuristics:
  // - >= 100000  → likely cents*100 (e.g., 299900) → divide by 100
  // - >  1000    → likely already cents (e.g., 2999 or "2999.00") → keep as-is
  // - otherwise  → likely dollars (e.g., 29.99) → *100 to cents
  if (num >= 100000) return Math.round(num / 100);
  if (num > 1000)    return Math.round(num);
  return Math.round(num * 100);
}

  async function fetchProductJson(handle) {
    if (!handle) return null;
    if (!pjCache.has(handle)) {
      pjCache.set(handle, fetch(`/products/${handle}.js`, { credentials: 'same-origin' })
        .then(r => r.ok ? r.json() : null).catch(()=>null));
    }
    return pjCache.get(handle);
  }
  async function lookupCompareAt(item) {
    const handle = item.handle || item.product_handle || item.url?.split('/products/')[1]?.split('?')[0];
    const vid = item.variant_id;
    if (!handle || !vid) return null;
    const pj = await fetchProductJson(handle);
    const v = pj?.variants?.find(v => Number(v.id) === Number(vid));
    if (!v) return null;
    return { cmp: toCents(v.compare_at_price), price: toCents(v.price) };
  }

  // savings logic (covers compare-at, line/cart discounts)
  function sumLineLevelDiscounts(item) {
    const allocs = item.discount_allocations || item.line_level_discount_allocations || [];
    return allocs.reduce((sum,a)=>{
      if (typeof a.amount === 'number') return sum + a.amount;
      const s = a.amount_set?.shop_money?.amount;
      return sum + (s ? Math.round(parseFloat(s)*100) : 0);
    },0);
  }
  async function computeSavings(cart, item) {
    const unitNow  = item.final_price ?? item.price ?? 0;
    const unitOrig = item.original_price ?? item.price ?? unitNow;

    let cmp = item.compare_at_price || item.variant_compare_at_price || null;
    if (!cmp) {
      const pj = await lookupCompareAt(item);
      if (pj?.cmp) cmp = pj.cmp;
    }

    let savedLine = 0;
    if (typeof item.original_line_price === 'number' && typeof item.final_line_price === 'number') {
      savedLine = Math.max(item.original_line_price - item.final_line_price, 0);
    }
    const lineLevel = sumLineLevelDiscounts(item);
    if (lineLevel > savedLine) savedLine = lineLevel;

    if (savedLine === 0 && cart.total_discount > 0 && cart.items_subtotal_price > 0) {
      const base = item.original_line_price ?? (unitOrig * (item.quantity || 1));
      const share = base / cart.items_subtotal_price;
      const prorated = Math.round(cart.total_discount * share);
      if (prorated > 0) savedLine = prorated;
    }

    const savedUnitFromCmp = cmp && cmp > unitNow ? (cmp - unitNow) : 0;
    const bestSavedLine = Math.max(savedLine, savedUnitFromCmp * (item.quantity || 1));

    const unitWas = cmp || unitOrig;
    const showWas = !!(cmp && cmp > unitNow);
    const showSave = bestSavedLine > 0;

    if (DEBUG) console.log('[badges] savings', { title: item.title, cmp, unitNow, bestSavedLine });
    return { showWas, unitWas, unitNow, savedLine: bestSavedLine };
  }

 function makeBadges(unitWas, unitNow, savedLine) {
  const wrap = document.createElement('div');
  wrap.className = `price-badges ${INJECTED_CLASS}`;

  if (savedLine > 0) {
    const save = document.createElement('span');
    save.className = 'badge badge--save';
    save.textContent = `Save ${money(savedLine)}`;

    // Optional: include % off for screen readers
    if (unitWas && unitWas > unitNow) {
      const sr = document.createElement('span');
      sr.className = 'sr-only';
      const pct = Math.round(((unitWas - unitNow) * 100) / unitWas);
      sr.textContent = `(${pct}% off per item)`;
      save.appendChild(sr);
    }

    wrap.appendChild(save);
  }

  return wrap;
}


  function attachSticky(lineEl, priceNode, builderFn) {
    const insert = () => {
      // remove previous injection next to this price node
      Array.from(priceNode.parentNode.children)
        .filter(n => n.classList?.contains(INJECTED_CLASS))
        .forEach(n => n.remove());
      const badges = builderFn();
      if (badges) priceNode.parentNode.insertBefore(badges, priceNode.nextSibling);
    };
    insert();

    // keep it there if Boost re-renders the line
    const obs = new MutationObserver(() => {
      const hasBadges = !!lineEl.querySelector(`.${INJECTED_CLASS}`);
      if (!hasBadges) insert();
    });
    obs.observe(lineEl, { childList: true, subtree: true });
  }

  function indexCart(cart) {
    const byKey = {}, byVid = {};
    cart.items.forEach(it => { if (it.key) byKey[it.key]=it; if (it.variant_id) byVid[it.variant_id]=it; });
    return { byKey, byVid, list: cart.items };
  }

  async function render() {
    const drawer = document.querySelector(DRAWER_SEL);
    if (!drawer) return;

    const cart = await getCart();
    const idx = indexCart(cart);

    const lines = drawer.querySelectorAll(LINE_SEL);
    if (DEBUG) console.log('[badges] lines found', lines.length);
    if (!lines.length) return;

    lines.forEach(async (lineEl, i) => {
      // match item by data-key, else by variant id, else by index
      let item = null;
      const key = keyFromEl(lineEl);
      const vid = vidFromEl(lineEl);
      if (key && idx.byKey[key]) item = idx.byKey[key];
      else if (vid && idx.byVid[vid]) item = idx.byVid[vid];
      else item = idx.list[i] || null;
      if (!item) return;

      const { showWas, unitWas, unitNow, savedLine } = await computeSavings(cart, item);
      if (!showWas && savedLine <= 0) return;

      const priceNode = lineEl.querySelector(PRICE_SEL) || lineEl;
      attachSticky(lineEl, priceNode, () => makeBadges(unitWas, unitNow, savedLine));
    });
  }

  // run and re-run on drawer/cart changes
  const mo = new MutationObserver(render);
  mo.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', render);
  ['cart:updated','cart:change','boost:cart:updated'].forEach(e=>window.addEventListener(e, render));
})();
